export const VOID_FOLDER_ID = -999;
export const ALL_FOLDER_ID = 0;
export const PERSONAL_FOLDER_ID = -9;
export const SEARCH_FOLDER_ID = -900;
export const PHY_LOC_FOLDER_ID = -910;

export const ALL_FOLDER_NAME = "All Folders";
export const PERSONAL_FOLDER_NAME = "Personal Folders";

export const SHORT_DATE_FORMAT = "DD/MM/YYYY";
export const SHORT_DATETIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const ISO_DATE_FORMAT = 'YYYY-MM-DDT00:00:00';

// Chop file for uploading
export const FILE_CHUNK_SIZE = 1024 * 1024 * 2;
export const UPLOAD_CONCURRENCY = 4;
export const MAX_FILE_SIZE = 1024 * 1024 * 1024 * 2; // 2GB max file size

export const SystemAdminEnum = {
	saData: 1,
	saSecurity: 2,
	saAuthDL: 4,
}


export const AccessRightEnum = {
	arNoAccess: 0,
	arReadIndex: 1,
	arReadDoc: 2,
	arReadHandle: 3,
	arReadPrint: 4,
	arReadDn: 5,
	arModify: 6,
	arModifyDel: 7,
	arFullControl: 8,
}

export const DmsLogEnum = {
	daLogin: 1,
	daAddFile: 2,
	daEditFile: 3,
	daOpenFile: 4,
	daDelFile: 5,
	daMoveFile: 6,
	daSimpleSearch: 7,
	daAdvanceSearch: 8,
	daContentSearch: 9,
	daOpenRevision: 10,
	daAttOpen: 14,
	daAttDownload: 15,
	daAttAdd: 16,
	daSrcOpen: 12,
	daSrcDownload: 17,
	daRevAdd: 13,
	daAuthDL: 18,
	daEditFolder: 22,
	daAddRequest: 23,
	daCheckIn: 24,
	daUpdRequest: 25,
	daDocDownload: 26,
	daCheckLogAttAdd: 27,
	daCheckLogAttDel: 28,
	daCheckLogAttDownload: 29,
	daCheckLogAttOpen: 30,
	daCreateShareDocLink: 31,
	daShareDocByEmail: 32,
	daRevDel: 33,
	daAplAllow: 34,
	daAplReject: 35,
	daAplCancelAction: 36,
	daAddSuperUser: 37,
	daShareDocBySendFile: 38,

	// iPad Log
	daIPadLogin: 101,
	daIPadOpenFile: 104,

	// iPhone Log
	daIPhoneLogin: 201,
	daIPhoneOpenFile: 204,
}

// class DmsLogEnum(IntEnum):
//     daLogin = 1
//     daAddFile = 2
//     daEditFile = 3
//     daOpenFile = 4
//     daDelFile = 5
//     daMoveFile = 6
//     daSimpleSearch = 7
//     daAdvanceSearch = 8
//     daContentSearch = 9
//     daOpenRevision = 10
//     daAttOpen = 14
//     daAttDownload = 15
//     daAttAdd = 16
//     daSrcOpen = 12
//     daSrcDownload = 17
//     daRevAdd = 13
//     daAuthDL = 18
//     daEditFolder = 22
//     daAddRequest = 23
//     daCheckIn = 24
//     daUpdRequest = 25
//     daDocDownload = 26
//     daCheckLogAttAdd = 27
//     daCheckLogAttDel = 28
//     daCheckLogAttDownload = 29
//     daCheckLogAttOpen = 30
//     daCreateShareDocLink = 31
//     daShareDocByEmail = 32
//     daRevDel = 33
//     daAplAllow = 34
//     daAplReject = 35
//     daAplCancelAction = 36
//     daAddSuperUser = 37
//     daShareDocBySendFile = 38

//     # iPad Log
//     daIPadLogin = 101
//     daIPadOpenFile = 104

//     # iPhone Log
//     daIPhoneLogin = 201
//     daIPhoneOpenFile = 204

export function AccessRightEnumToStr(aRight) {
	switch (aRight) {
		case AccessRightEnum.arNoAccess:
			return "No Access"
		case AccessRightEnum.arReadIndex:
			return "Read Index"
		case AccessRightEnum.arReadDoc:
			return "Read Document"
		case AccessRightEnum.arReadHandle:
			return "Read and Handle/Check-In"
		case AccessRightEnum.arReadPrint:
			return "Read and Print"
		case AccessRightEnum.arReadDn:
			return "Read and Download"
		case AccessRightEnum.arModify:
			return "Modify"
		case AccessRightEnum.arModifyDel:
			return "Modify and Delete"
		case AccessRightEnum.arFullControl:
			return "Full Control"
		default:
			return " "
	}
}

export const ActionListEnum = {
	alForReference: 0,
	alForComment: 1,
	alForApproval: 2,
}

export function ActionEnumToStr(aAction) {
	switch (aAction) {
		case ActionListEnum.alForReference:
			return "For Reference"
		case ActionListEnum.alForComment:
			return "For Comment"
		case ActionListEnum.alForApproval:
			return "For Approval"
		default:
			return " "
	}
}

export function CreateUUID() {
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	)
}

export function CreateFileID() {

	return CreateUUID().toUpperCase().replace(/-/g, "");
}

export function sleep(AMilliSecond) {
	return new Promise(resolve => setTimeout(resolve, AMilliSecond));
}

export function getFileExtension(AFilename) {
	var ext = /^.+\.([^.]+)$/.exec(AFilename);
	return ext == null ? "" : "." + ext[1];
}

export function getReadableFileSizeString(vBytes) {

	// Using the same logic in iPad
	var v1KB = 1024;
	var v1MB = Math.pow(1024, 2);
	var v1GB = Math.pow(1024, 3);

	if (vBytes == 0) {
		return " ";
	} else if (vBytes > 0 && vBytes < v1KB) {
		return vBytes + ' bytes';
	} else if (vBytes >= v1KB && vBytes < v1MB) {
		return (vBytes / v1KB).toFixed(1) + ' KB';
	} else if (vBytes >= v1MB && vBytes < v1GB) {
		return (vBytes / v1MB).toFixed(1) + ' MB';
	} else if (vBytes >= v1GB) {
		return (vBytes / v1GB).toFixed(3) + ' GB';
	}
};

export const validateEmail = (aEmail) => {
	if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(aEmail)) {
		return (true)
	}
	return (false)
}

export const getUrlParam = (AParamName) => {
	var vPageUrl = window.location.search.substring(1);
	return getUrlParam2(vPageUrl, AParamName)
}

export const getUrlParam2 = (AUrl, AParamName) => {

	var vUrlVariables = AUrl.split('&');
	for (var i = 0; i < vUrlVariables.length; i++) {
		var vParamName = vUrlVariables[i].split('=');
		if (vParamName[0] == AParamName) {
			return vParamName[1];
		}
	}
}

export const encodeStrForPassing = (aStr) => {
	return encodeURIComponent(Buffer.from(aStr).toString('base64'));
}

export const decodeStrFromPassing = (aEncodedStr) => {
	return Buffer(decodeURIComponent(aEncodedStr), 'base64').toString('utf8');
}

export const base64ToUTF8 = (base64String) => {
	const decodedString = atob(base64String);
	return decodeURIComponent(escape(decodedString));
}

export const setCookie = (name, value, days = 1) => {
	const expires = new Date(Date.now() + days * 86400000).toUTCString();
	document.cookie =
		`${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
}

export const getCookie = (name) => {
	const cookies = document.cookie.split('; ');
	for (let i = 0; i < cookies.length; i++) {
		const [cookieName, cookieValue] = cookies[i].split('=');
		if (cookieName === name) {
			return decodeURIComponent(cookieValue);
		}
	}
	return null;
}

export const deleteCookie = (name) => {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export const getBrowserInfo = () => {
	const ua = navigator.userAgent;
	let match;

	if ((match = ua.match(/Edg\/(\d+)/))) {
		return { name: "Edge", version: match[1] };
	}
	if ((match = ua.match(/Chrome\/(\d+)/))) {
		return { name: "Chrome", version: match[1] };
	}
	if ((match = ua.match(/Firefox\/(\d+)/))) {
		return { name: "Firefox", version: match[1] };
	}
	if ((match = ua.match(/Version\/(\d+).+Safari/))) {
		return { name: "Safari", version: match[1] };
	}
	if ((match = ua.match(/MSIE (\d+)/)) || ua.match(/Trident\/.*rv:(\d+)/)) {
		return { name: "Internet Explorer", version: match[1] };
	}

	return { name: "Unknown", version: "Unknown" };
}

